import styled from "styled-components";
import { MD_SCREEN } from "../util/screen-size";

export const getStyledImageHolder = () => styled.div`

    

    @media (max-width: ${MD_SCREEN}px) {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    img{
        z-index: 0;
        @media (min-width: ${MD_SCREEN}px) {
            float: right;
        }

        @media (max-width: ${MD_SCREEN}px) {
            object-fit: cover;
            height: 100%;
            width: 100%;
            filter: blur(2px);
        }
        
    }

    .overlay{
        height: 92vh;
        width: 100%;
        position: absolute;
        z-index: 1;
        box-shadow: 5px 5px 150px 200px rgba(183, 183, 183, .45) inset;
    }
`

export const getStyledHomeActions = () => styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    column-gap: 45vw;
    
    z-index: 2;
    top: 0;
    
    padding: 0 5px;
    
    height: 12vh;
`

export const getStyledHomeActionWrapper = () => styled.div`
    display: flex;
    align-items: center;
    column-gap: 5vw;
`

export const getStyledHeroTextContainer = () => styled.div`
    display: flex;
    flex-direction: column;
    margin: 4vh 4vw;
    row-gap: 2vh;
    
    @media (max-width: ${MD_SCREEN}px) {
        width: 60vw;
        color: #001414;
    }

    @media (min-width: ${MD_SCREEN}px) {
        width: 30vw;
        color: #001414;
    }
    
    .title{
        @media (min-width: ${MD_SCREEN}px) {
            font-size: 5em;
        }
        font-size: 3em;
        font-family: 'Playfair Display', serif;
        font-weight: 600;
    }
    
    .description{
        font-size: 1.5em;
        text-align: justify;
        font-weight: 300;
    }
`
export const getStyledDotsContainer = () => styled.div`
    position: absolute;
    z-index: 5;

    @media (max-width: ${MD_SCREEN}px) {
        margin-left: 60vw;
        margin-bottom: 40vh;
    }

    @media (min-width: ${MD_SCREEN}px) {
        left: 0;
        top: 0;
        margin-top: 6vh;
        margin-left: 15vw;
    }
    
`

export const getStyledBrandsContainer = () => styled.div`
    background-color: rgb(244, 246, 246);
    height: 20vh;

    @media (max-width: ${MD_SCREEN}px) {
        width:100%;
        z-index: 5;
        position: absolute;
        top: 0;
        margin-top: 72.1vh;
    }
    
    @media (min-width: ${MD_SCREEN}px) {
        width:calc(100% + 20vw);
        margin-left: -20vh;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 5vh;
    
    .title{
        margin-top: 3vh;
        text-transform: uppercase;
        font-size: 1.2em;
        color: #031745;
        letter-spacing: 1.5px;
    }

    .logo-container{
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 5vw;
    }
`